import { awsApiUrl } from "./analysis";

export const getHistogramGroup = async (
  value,
  color,
  newTitle,
  yLabel,
  xLabel
) => {
  const payload = {
    value,
    legend: color,
    xlabel: xLabel,
    ylabel: yLabel,
    title: newTitle,
  };
  // console.log(payload);
  const res = await fetch(`${awsApiUrl}/getHistoGroup`, {
    method: "POST",
    body: JSON.stringify(payload),
    headers: {
      "Content-type": "application/json",
    },
  });

  const result = res ? await res.json() : false;
  // console.log("getHistogramGroup: >>", result);
  return result;
};
